import { DeviceType } from 'src/API';

// デバイスタイプを判別する関数
export const detectDeviceType = (): DeviceType => {
  if (typeof window === 'undefined') return DeviceType.DESKTOP; // SSRの場合はデスクトップを返す

  const userAgent = window.navigator.userAgent.toLowerCase();
  const isMobile = /iphone|ipad|ipod|android|mobile|blackberry|iemobile|opera mini/i.test(
    userAgent
  );

  return isMobile ? DeviceType.MOBILE : DeviceType.DESKTOP;
};
